module.exports = __webpack_public_path__ + "img/5.62f53c58.png";